import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DatepickerRendererService {
  private _renderer: Renderer2;

  constructor(private _rendererFactory: RendererFactory2) {
    this._renderer = this._rendererFactory.createRenderer(null, null);
  }

  renderRemoveDateButton(): void {
    const calendarContentElement = document.querySelector<HTMLButtonElement>('.mat-calendar-content');
    this._renderer.appendChild(calendarContentElement, this.createRemoveButtonElement());
  }

  createRemoveButtonElement(): HTMLButtonElement {
    const removeButtonElement = this._renderer.createElement('mat-button') as HTMLButtonElement;
    const buttonText = this._renderer.createText('Remove date');
    this._renderer.addClass(removeButtonElement, 'mat-button');
    this._renderer.addClass(removeButtonElement, 'remove-date-button');
    this._renderer.appendChild(removeButtonElement, buttonText);
    return removeButtonElement;
  }
}
